import { useTranslation } from 'react-i18next';
import { Card, Col, Row } from 'reactstrap';

import PricingLoader from './Loader';
import CertificatesSection from './sections/CertificatesSection';
import ChargeItemsSection from './sections/ChargeItems';
import CostCentersSection from './sections/CostCenters';
import PetitionsSection from './sections/PetitionsSection';
import TitulationPaymentSection from './sections/TitulationPaymentSection';

const dictPrefix = 'financialPortal.settings';

/**
 * Precios de certificados, solicitudes y derecho a grado (venían de
 * Configuración > Financieros - otros) y los mantenedores de centros de costo e
 * ítems de cargo. Cada sección de precios guarda por su cuenta: no hay botón
 * global.
 */
export default function CostCentersAndChargeItemsTab() {
  const { t } = useTranslation();

  return (
    <Card className="p-4">
      <p className="fs-16 mb-4">{t(`${dictPrefix}.pricing.intro`)}</p>

      <p className="fs-20 fw-700 text-primary text-uppercase mb-4">
        {t(`${dictPrefix}.pricing.title`)}
      </p>
      <PricingLoader>
        <Row>
          <Col xs={12} lg={6}>
            <CertificatesSection />
            <TitulationPaymentSection />
          </Col>
          <Col xs={12} lg={6}>
            <PetitionsSection />
          </Col>
        </Row>
      </PricingLoader>

      <p className="fs-20 fw-700 text-primary text-uppercase mt-5 mb-4">
        {t(`${dictPrefix}.costsAndCharges.title`)}
      </p>
      <CostCentersSection />
      <ChargeItemsSection />
    </Card>
  );
}
